document.addEventListener('click', (e) => {
  if (e.target.classList.contains('js-dropdownBtn')) {
    const trigger = e.target;
    const target = trigger.parentElement.querySelector('.js-dropdown');

    if (trigger && target) {
      trigger.classList.toggle('is-open');
      target.classList.toggle('is-open');
    }
  }
});
